<template>
  <div class="forum-background">
    <div class="forum-banner">
      <div class="forum-container">
        <div class="forum-banner-title">申请试用</div>
      </div>

      <img class="forum-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="forum-container">

     <div class="forum-content">
       <div class="forum-content-title">
         <div class="forum-content-title-text">填写申请表格</div>
       </div>
<iframe height="800" allowTransparency="true" scrolling="no" style="display:block;min-width:100%;width:100px;border:none;overflow:auto;" frameborder="0" src="http://longxun2015.mikecrm.com/y72WBOU"></iframe>
     </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "trialPage",
    methods:{
      toCompanyNews(){
        this.$router.push({ name: 'CompanyNews'})
      }
    },
    created() {
    }
  }
</script>

<style scoped>
  .forum-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .forum-background{
    margin-top: 70px;
  }
  .forum-banner{
    overflow:hidden;
  }
  .forum-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .forum-banner-img{
    min-width:100%;
    height:165px;
  }
  .forum-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .forum-content-title{
    padding-top: 50px;
    text-align: center;
  }
  .forum-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .forum-content-info{
    margin-top: 50px;
  }
  .forum-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .forum-a{
    color:rgba(73,145,201,1)!important;
    cursor: pointer;
  }
  .forum-a:hover,
  .forum-a:active,
  .forum-a:focus{
    text-decoration: underline !important;
  }
  .forum-content-info-title-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight: bolder;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .forum-content-info-title-fa{
    font-size: 16px;
    padding-right: 8px;
  }
  @media screen and (max-width:482px) {
    .forum-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .forum-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .forum-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .forum-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .forum-container{
      max-width: 1068px;
    }
  }

</style>
